<template>
  <div>
    <question :idx="5">
      <p class="title">5、作为商品房出售的新建物业，物业管理区域内房屋的出售和交付需要一个过程（）</p>
      <ul>
        <li class="error"><span style="display: none">A</span><Icon type="md-close-circle" color="#ff3300"/>施工单位</li>
        <li><span>B</span>建设单位</li>
        <li class="zhengque"><span style="display: none">C</span><Icon type="md-checkmark-circle" color="#009900"/>分包单位</li>
        <li><span>D</span>监理单位</li>
      </ul>
      <Button  class="btn" @click="sumit">提交</Button>
    </question>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
</style>
<script type="text/ecmascript-6">
  import question from '../template/question'
    export default {
        name: '',
        props: {},
        data() {
            return {};
        },
        methods: {
          sumit(){
            this.$router.push({
              path: '/jieguo'
            })
          }
        },
        created() {

        },
        components: {
          question
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/question/qus5.vue